import { Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { ExpiredLinkDesktopIcon } from '@icons/ExpiredLinkDesktopIcon';
import { ExpiredLinkMobileIcon } from '@icons/ExpiredLinkMobileIcon';
import NavBarComponent from '../NavBar/NavBar';
import { useContext } from 'react';
import { LocalizationContext } from '@context/LocalizationContext';

export const ExpiredLinkScreen = () => {
	const theme = useTheme();
	const greaterThanSmall = useMediaQuery(theme.breakpoints.up('sm'));
	const { ExpiredLinkScreen } = useContext(LocalizationContext);

	return (
		<Stack data-cy={'oucfExpiredLinkScreen'} height={'100%'} width={'100%'}>
			<NavBarComponent isQuestionTrailDisplayed={false} showLanguageSelector={true} />
			<Stack
				paddingInline={{
					xxs: '24px',
					xs: '24px',
					sm: '48px',
					md: '105px',
					lg: '350px',
					xl: '403px',
				}}
				paddingTop={'10%'}
				height={'100%'}
				justifyContent={'center'}
				alignItems={'center'}
				gap={'15px'}>
				{greaterThanSmall ? <ExpiredLinkDesktopIcon /> : <ExpiredLinkMobileIcon />}
				<Typography textAlign={'center'} variant={'finalScreenTitle'}>
					{ExpiredLinkScreen.Title}
				</Typography>
				<Typography textAlign={'center'} variant={'finalScreenSubtitle'}>
					{ExpiredLinkScreen.Message}
				</Typography>
			</Stack>
		</Stack>
	);
};
